// This provides an interface to access all the controllers using this mixin.
//  Note that this mixin only works for stimulus controller located in the same page.

// Steps to use this mixin on a stimulus controller:
//  1. Import this mixin.
//  2. Call useCollapser(this) on your connect. (Assuming it was imported as useCollapser)
//  5. Define a collapsable target
//      This corresponds to the elements that will be collapsed/expand after triggering the
//      corresponding method
//  6. Define the data-${identifier}-collapse-by attribute on the collapsable targets
//     where you want to collapse them by custom classes

export const useCollapser = controller => {
  Object.assign(controller, {
    // PUBLIC
    // this._isCollapsed var used for tracking if everything is collapsed or not.

    // Expand all collapsable elements
    expand() {
      this.collapsableTargets.forEach((elem) => {
        this.toggleElem(elem, false)
      })
      this._isCollapsed = false
    },

    // Collapse all collapsable elements
    collapse() {
      this.collapsableTargets.forEach((elem) => {
        this.toggleElem(elem, true)
      })
      this._isCollapsed = true
    },

    // Check if it's collapsed
    isCollapsed() {
      return this._isCollapsed
    },

    // PRIVATE
    toggleElem(elem, collapse) {
      const collapseByClass = this.collapseByClass(elem)
      const isActionDefault = collapseByClass === null || collapseByClass === undefined || collapseByClass === ''

      if (isActionDefault) {
        this.toggleByDefaultClass(elem, collapse)
      } else {
        this.toggleByCustomClass(elem, collapseByClass, collapse)
      }
    },

    collapseByClass(elem) {
      return elem.getAttribute(`data-${this.identifier}-collapse-by`)
    },

    toggleByCustomClass(elem, collapseByClass, collapse) {
      const cssClasses = collapseByClass.split(' ')
      if (collapse) {
        cssClasses.forEach((klass) => {
          elem.classList.add(klass)
        })
      } else {
        cssClasses.forEach((klass) => {
          elem.classList.remove(klass)
        })
      }
    },

    toggleByDefaultClass(elem, collapse) {
      if (collapse) {
        elem.classList.add('animate-collapse')
        elem.addEventListener('animationend', () => {
          elem.classList.remove('animate-collapse')
          elem.classList.add('hidden')
        }, { once: true })
      } else {
        elem.classList.remove('hidden')
        elem.classList.add('animate-expand')
        elem.addEventListener('animationend', () => {
          elem.classList.remove('animate-expand')
        }, { once: true })
      }
    }
  })

  controller._isCollapsed = false
}
